import { Box, Typography } from '@mui/material'

const CardBlock = ({ title, subtitle, content }) => {
  return (
    <Box sx={{
      my: '8px',
      p: '6px 10px',
      border: 'none',
      borderRadius: 'var(--app-radius-md)',
      bgcolor: 'background.default',
      boxShadow: 'none',
    }}>
      {title && (
        <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.secondary', mb: subtitle || content ? '6px' : 0 }}>
          {title}
        </Typography>
      )}
      {subtitle && (
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: content ? '6px' : 0 }}>
          {subtitle}
        </Typography>
      )}
      {content ? (
        <Typography variant="body2" sx={{ color: 'text.primary' }}>
          {content}
        </Typography>
      ) : null}
    </Box>
  )
}

export default CardBlock
